import React from 'react';

/**
 * Full-viewport call shell with backdrop blur, used for initializing and idle waiting states.
 */
const CallScreenCenteredMessage = ({ message, variant = 'plain' }) => (
  <div className="call-wrapper call-wrapper_backdrop_blur d-flex flex-column align-items-center justify-content-center py-4">
    {variant === 'card' ? (
      <div className="call-card p-4 text-center">
        <p className="text-light mb-0">{message}</p>
      </div>
    ) : (
      <p className="text-light">{message}</p>
    )}
  </div>
);

export default CallScreenCenteredMessage;
